import Spinner from "./Spinner.view";

export default Spinner;
